export default class PasswordValidation {
    static lowercaseCondition(password: string): boolean {
        return /[a-z]/.test(password);
    }
    static uppercaseCondition(password: string): boolean {
        return /[A-Z]/.test(password);
    }
    static characterMinimumCondition(password: string): boolean {
        return password !== undefined && password !== null && password.length >= 8;
    }
    static numberSymbolCondition(password: string): boolean {
        const number = /[0-9]/.test(password);
        if (number) {
            return true;
        }

        const validSymbols = SERVER.VALID_SYMBOLS_FOR_PASSWORDS ?? '';
        for (let i = 0; i < validSymbols.length; i++) {
            const symbol = validSymbols[i];
            if (password.indexOf(symbol) >= 0) {
                return true;
            }
        }
        return false;
    }
}
